// 微信小程序中需要用到的API，包括移动端与开放平台的API
export const APPLET_BASE_INFO = '/api/v1/wechat_applet/get_applet_base_info'
export const APPLET_SAVE_FILE_USER = '/api/v1/wechat_applet/create_file_user'
export const WX_LOGIN = '/apps/users/is_user_logged_in'
